var _ = require("lodash");
var defaults = require("./default.js");
var config = require("./" + (process.env.NEXT_PUBLIC_AUTOMATEVIDEO_ENV || "development") + ".js");
module.exports = _.merge({}, defaults, config);
